import { LocalStorageKeys } from '@/helpers/enums';
import { FacilityWorker } from '@/providers/laundryheap/interfaces/facility-worker';
import {
  MobileAppData,
  MobileInsetsData,
} from '@/providers/laundryheap/interfaces/general';
import * as Sentry from '@sentry/vue';
import { SeverityLevel } from '@sentry/vue';

export const sendErrorToSentry = (
  errorKey?: string,
  extraPayload?: Record<string, unknown>,
  level: SeverityLevel = 'error'
): void => {
  if (!import.meta.env.VITE_SENTRY_DSN) {
    switch (level) {
      case 'error':
        console.error(errorKey, extraPayload);
        break;
      case 'info':
      default:
        console.info(errorKey, extraPayload);
        break;
    }
    return;
  }

  additionalSentryTags();
  Sentry.captureMessage(errorKey || 'Unknown error key', {
    level: level,
    extra: extraPayload,
  });
};

export const captureExceptionToSentry = (e?: Error): void => {
  if (!import.meta.env.VITE_SENTRY_DSN) {
    console.error(e);
    return;
  }

  additionalSentryTags();
  Sentry.captureException(e);
};

export const sentryCaptureExceptionAndData = (
  e: Error,
  extra?: Record<string, unknown>
): void => {
  if (!import.meta.env.VITE_SENTRY_DSN) {
    console.error(e);
    return;
  }

  additionalSentryTags();
  Sentry.captureException(e, extra);
};

export const isAuthenticated = (): boolean => !!getToken();
export const getToken = (): string | null =>
  localStorage.getItem(LocalStorageKeys.token);

export const getMobileAppData = (): MobileAppData | null =>
  JSON.parse(localStorage.getItem(LocalStorageKeys.mobileAppData) || 'null');
export const getMobileInsetsData = (): MobileInsetsData | null =>
  JSON.parse(localStorage.getItem(LocalStorageKeys.mobileAppInsets) || 'null');
export const userData = {
  get data(): FacilityWorker | null {
    return JSON.parse(
      localStorage.getItem(LocalStorageKeys.userData) || 'null'
    );
  },
  set data(value: FacilityWorker | null) {
    localStorage.setItem(LocalStorageKeys.userData, JSON.stringify(value));
  },
};

// Private methods
const additionalSentryTags = (): void => {
  const mobileAppData = getMobileAppData();
  Sentry.setUser({ id: userData.data?.id });
  Sentry.setTag('facility_id', userData.data?.facility?.id);
  Sentry.setTag('facility_name', userData.data?.facility?.name);
  Sentry.setTag('mobile_version', mobileAppData?.version);
  Sentry.setTag('mobile_build', mobileAppData?.build);
  Sentry.setTag('error_source', 'Webapp');
};
